import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import useFetchPOST from "../useFetchPOST";
import CustomError from '../CustomError';

const Login = ( {setAuth} ) => {
    const [formData, setFormData] = useState({
        userName: '',
        userPasswd: ''        
    })
    
    const [submitData, setSubmitData] = useState(null); // State to trigger fetch
    const {error, responseData, loading} = useFetchPOST('https://api.plusat.be/login', submitData);
    const navigator = useNavigate();

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
          ...prev,
          [name]: value,
        }));
      };
      
    const handleSubmit = async (e) => {
        e.preventDefault();                    
        setSubmitData(formData);                
    };      

    useEffect(() => {
        if (loading) return;        

        if (!error && responseData)
        {
            localStorage.setItem('token', responseData.token);
            localStorage.setItem('userName', responseData.userName);
            localStorage.setItem('userId', responseData.userId);
            
            setAuth(true);            
            setTimeout( () => {
                navigator('/index');
            }, 500)
        }        
    })
    
    return (
        <div className="new">
            <h2>Please input credentials</h2>
            <form onSubmit={handleSubmit}>            
                <fieldset className="new-panel">
                    <legend>Details:</legend>
                    <label htmlFor="userName">user name: &nbsp;</label><input type="text" name="userName" id="userName" value={formData.userName} onChange={handleChange}/>
                    <label htmlFor="userPasswd">password: &nbsp;</label><input type="text" name="userPasswd" id="userPasswd" value={formData.userPasswd} onChange={handleChange}/>                    
                </fieldset>
                <br />                
                <button type="submit">login</button>
            </form>

            {error && <CustomError error={error}/>}
        </div>
    )
}

export default Login;